import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { KlmDashboardComponent } from '../klm-dashboard/klm-dashboard.component';
import { KlmFooterComponent } from './klm-footer/klm-footer.component';
import { KlmHeaderComponent } from './klm-header/klm-header.component';
import { KlmSidebarComponent } from './klm-sidebar/klm-sidebar.component';
import { AdminstrationComponent } from '../adminstration/adminstration.component';
import { RoleComponent } from '../adminstration/role/role.component';
import { UserComponent } from '../adminstration/user/user.component';
import { DataAssignmentComponent } from '../adminstration/data-assignment/data-assignment.component';
import { WorkFlowComponent } from '../adminstration/work-flow/work-flow.component';
import { SettingComponent } from '../setting/setting.component';
import { CodeValueComponent } from '../setting/code-value/code-value.component';
import { FieldComponent } from '../setting/field/field.component';
import { HierachyComponent } from '../setting/hierachy/hierachy.component';
import { KlmManageComponent } from '../klm-manage/klm-manage.component';
import { KlmBookingComponent } from '../klm-booking/klm-booking.component';
const routes: Routes = [
  {
    path: "KALYANMANDAP-index",
    component: KlmDashboardComponent,
    //canActivate: [RoleGuardService], data: { ComponentCode: 'EMD-R1' }
  },
  {
    path: "klm-manage",
    component: KlmManageComponent
  },
  
  {
    path: "klm-booking",
    component: KlmBookingComponent,
  },

  {
    "path": "administration",
    "component": AdminstrationComponent,
    "children": [


      {
        path: "roles",
        component: RoleComponent,
        // canActivate: [RoleGuardService], data: { ComponentCode: 'USTP-R7' }
      },
      {
        path: "users",
        component: UserComponent,
        // canActivate: [RoleGuardService], data: { ComponentCode: 'USTP-R8' }
      },

      {
        path: "data-assignment",
        component: DataAssignmentComponent
        //  canActivate: [RoleGuardService], data: { ComponentCode: 'USTP-R9' }
      },

      {
        path: "workflow",
        component: WorkFlowComponent
        // canActivate: [RoleGuardService], data: { ComponentCode: 'USTP-R10' }
      },

    ]
  },

  {

    "path": "klm-setting",
    "component": SettingComponent,
    "children": [
      {
        path: "code-value",
        component: CodeValueComponent,
        // canActivate: [RoleGuardService], data: { ComponentCode: 'USTP-R12' }
      },
      {
        path: "field",
        component: FieldComponent,
        //  canActivate: [RoleGuardService], data: { ComponentCode: 'USTP-R11' }
      },

      {
        path: "hierachy",
        component: HierachyComponent,
        //  canActivate: [RoleGuardService], data: { ComponentCode: 'USTP-R14' }

      }

    ]

  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KlmLayoutRoutingModule { }
